var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHikingAndTrekking = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Trekking-Person--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Trekking Person Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.59 3.12a2.5 2.5 0 1 0 5 0 2.5 2.5 0 1 0 -5 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.58 7.4a1 1 0 0 0 -1.21 0.73l-3.5 14a1 1 0 0 0 0.73 1.21 1 1 0 0 0 1.21 -0.72l3.5 -14a1 1 0 0 0 -0.73 -1.22Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 8.79a0.25 0.25 0 0 0 0 -0.19 0.26 0.26 0 0 0 -0.16 -0.11l-3.89 -1a0.25 0.25 0 0 0 -0.31 0.18l-0.71 2.85a1.62 1.62 0 0 0 0.2 1.27c0.52 0.86 2.4 1.06 2.58 1.06a1.66 1.66 0 0 0 1.59 -1.23Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86 7.52a0.26 0.26 0 0 0 0.31 -0.18l0.15 -0.62a1.62 1.62 0 0 0 -0.2 -1.27 1.65 1.65 0 0 0 -1 -0.75l-1.21 -0.26a1.68 1.68 0 0 0 -2 1.22l-0.14 0.58a0.21 0.21 0 0 0 0 0.19 0.21 0.21 0 0 0 0.23 0.11Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.72 13.62a1.5 1.5 0 0 0 0 -3 5 5 0 0 1 -4.65 -3.17 1.5 1.5 0 0 0 -2.8 0.3l-3.5 13.5a1.5 1.5 0 1 0 2.91 0.75l1.15 -4.44a8.06 8.06 0 0 1 1.91 4.25 1.5 1.5 0 0 0 3 -0.37 11 11 0 0 0 -4 -7.19l0.69 -2.67a7.93 7.93 0 0 0 5.29 2.04Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHikingAndTrekking);
export default ForwardRef;